import React from 'react'

import {
  StyleSheet,
  View,
  ScrollView,
  Text
} from 'react-native'

import {
  adaptive, typography, colors
} from '@sart/styles'
import {
  Space,
  MoonDial,
  BalanceItem
} from '@sart/components'
import { useContent } from '@sart/content'
import client from '@sart/client'
// import { HomePhone } from '@sart/icons'

export default function HomePhoneMinutes(props) {
  // const { navigation } = props
  const content = useContent()

  const {
    cache: {
      homePhoneBalance,
      contextService,
			language
    } = {}
  } = client

  return (
    <ScrollView
      style={styles.container}
    >
      <View style={styles.wrapper} >
        {contextService &&
					<View>
					<Space height={12} />
					<View style={styles.numberContainer}>
							<View style={styles.iconContainer}>
									{/* <HomePhone /> */}
							</View>
							<Space width={10} />
							<Text style={styles.numberText}>{contextService.lineIdentifier}</Text>
							<Space width={10} />
					</View>
					<Space height={12} />
			</View>
        }
        <View style={styles.dial}>
          <MoonDial
            name={content.dashboard.minutes}
            size={192}
            value={homePhoneBalance.displayBalanceUnits}
            range={homePhoneBalance.displayStartingBalanceUnits}
            style={styles.moondialStyle}
            strokeColour={colors.srGreen + 20}
            mostlyFullColour={colors.srDarkGreen}
            almostEmptyColour={colors.srGreen}
            mostlyFullTextColour={colors.srTextInput}
            almostEmptyTextColour={colors.srTextInput}
            textColour={colors.srTextInput}
						injectedContent={content}
          />
        </View>
        <Space height={24} />
        {homePhoneBalance.breakdown && homePhoneBalance.breakdown.map((balance, i) =>
          <React.Fragment key={i}>
            <BalanceItem
              iconColor={colors.white}
              placeholderStyle={styles.balanceItem}
              balance={balance}
							language={language}
							injectedContent={content}
            />
            <Space height={24} />
          </React.Fragment>
        )}
      </View>
    </ScrollView>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingTop: 24,
    ...adaptive.wrapperPadding,
  },
  wrapper: {
    paddingBottom:12
  },
  dial: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  moondialStyle: {
    ...typography.lightbold
  },
  balanceItem: {
    backgroundColor: colors.srGreen
  },
  moondialTextStyle: {
    ...typography.lightbold,
    color: colors.srTextInput
  },
  numberText: {
    textAlign: 'center',
    ...typography.extrabold,
    fontSize: 20
  },
	numberContainer: {
			flexDirection: 'row',
			justifyContent: 'center',
	},
	iconContainer: {
		justifyContent: 'center'
	}
})


